// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__12P_1","head":"ProcedureTableInfo_head__rjzg0"};